export const salesCadenceMessages = {
	MSG_PROJECTION_GUIDANCE: `A projeção orienta a Cadência de Vendas do mês selecionado. Entre com a sua projeção ao longo dos dias do mês. Observação: não é permitido atingir uma projeção maior que 100%, portanto cuide para distribuir sua cadência ao longo dos dias de forma adequada.`,
	MSG_ERROR_PROJECTION_EXCEEDED: 'Erro ao receber valor!',
	MSG_ERROR_PROJECTION_DESCRIPTION:
		'Cadência de vendas não pode ser maior que 100%! Por favor, distribua os valores ao longo do mês para totalizar 100%!',
	MSG_WEEKEND_SUNDAY: 'Domingo',
	MSG_WEEKEND_SATURDAY: 'Sábado',

	LABELS: {
		YEAR: 'Ano',
		MONTH: 'Mês',
		SELECT_PLACEHOLDER: 'Selecione',
		PROJECTION_PERCENTAGE: 'Projeção (%)',
		DAYS: 'DIAS',
		YEAR_DAYS: 'ANO {year} - DIAS',
		MONTHLY_PROJECTION_TOTAL: 'Total da Projeção Mensal',
		CHECK_MONTH: 'Confira o mês',
		CANCEL: 'Cancelar',
		SAVE: 'Salvar',
	},

	PLACEHOLDER: {
		PERCENTAGE: '%',
	},

	SCREEN_TITLES: {
		SALES_CADENCE: 'Cadência de Vendas',
	},
} as const;

export type SalesCadenceMessageType =
	(typeof salesCadenceMessages)[keyof typeof salesCadenceMessages];
